<template>
    <div class="center user-dropdown">
        <div class="dropbtn center">
            <span class="username">{{username}}</span>
            <div class="avatar-circle">
                <span class="initials">{{this.initials}}</span>
            </div>
        </div>
        <div class="dropdown-content">
            <div class="usermail">{{usermail}}</div>
            <div class="logout-row" @click="logout">
                <span class="icon icon-logout"></span>
                <div class="nav-links">Logout</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "UserDropdown",
        props:[
            'username',
            'usermail'
        ],
        computed:{
            initials:function () {
                let split = this.username.split(' ');
                if(split.length >= 2){
                    let firstLetter = split[0].substr(0,1);
                    let secondLetter = split[split.length-1].substr(0,1);
                    return (firstLetter+secondLetter).toUpperCase();
                }else{
                    return 'U';
                }

            }
        },
        methods: {
            logout() {
                // eslint-disable-next-line no-undef
                sso.init({
                    logoutEndpoint: "https://sso.adalliance.io/api/users/globalsession/logout"
                });
                // eslint-disable-next-line no-undef
                sso.logout();
                this.$noty.success('Sie wurden erfolgreich ausgeloggt! Um sich erneut anzumelden, einfach die Seite neu laden.')
            }
        }
    }
</script>

<style lang="scss" scoped>

    .right-align {
        float: right;
    }

    .dropbtn{
        display: flex;
        align-items: center;
      justify-content: flex-end;
    }

    .username {
        font-size: 16px;
        padding-right: 10px;
        display: inline-block;
        cursor: default;
    }

    .usermail{
        white-space: pre;
    }

    .avatar-circle {
        display: inline-block;
        width: 40px;
        height: 40px;
        background-color: #36444D;
        text-align: center;
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
    }

    .initials {
        position: relative;
        top: 10px;
        font-size: 15px;
        line-height: 15px;
        color: #fff;
        font-weight: bold;
    }

    .user-dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #fff;
        text-align: right;
        font-size: 15px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        z-index: 20;
        padding: 12px 16px;
        right: -5px;
    }

    .dropdown-content span {
        cursor: default;
        word-break: break-all;

    }

    .dropdown-content a, .dropdown-content span {
        color: black;
        text-decoration: none;
        display: inline-block;
    }

    .logout-row {
        padding-top: 12px;
        width:100%;
        display: flex;
        justify-content: center;
        cursor: pointer;

        .icon{
            padding-right: 5px;
            top:1px;
            position: relative;
        }
    }

    .dropdown-content img {
        display: inline-block;
        height: 20px;
    }


    .user-dropdown:hover .dropdown-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .logout-row:hover{
        .nav-links, .icon{
            color: #00b6ed;
        }
    }
</style>